/**
 * 补打卡 - 我的申请
 */
import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';

import Header from '../../components/Header/Header.jsx';
import PullLoader from '../../components/PullLoader/PullLoader.jsx';
import RecordList from '../../components/RecordList/RecordList.jsx';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import Form from '../../components/Form/Form.jsx';
import Loader from '../../components/Loader/Loader.jsx';
import PageOpener from '../../components/PageOpener/PageOpener.jsx';

import RepairClockInStore from '../../stores/RepairClockInStore';
import RepairClockInDataUtils from '../../data-utils/RepairClockInDataUtils';
import LeaveDataUtils from '../../data-utils/LeaveDataUtils';

class RepairClockInList extends Component {
	static getStores() {
		return [RepairClockInStore];
	}

	static calculateState() {
		return RepairClockInStore.getState();
	}
	constructor(props) {
		super(props);
		// RepairClockInDataUtils.getEmpRciList({
		// 	page: 1,
		// 	state: 'approving'
		// });
		// RepairClockInDataUtils.empRciApplyList({
		// 	page: 1,
		// 	state: 'approving'
		// });
		//RepairClockInDataUtils.getRciEditApplyForm(1004);

		//获取右上角筛选列表
		RepairClockInDataUtils.getFilter(JSON.parse(localStorage.getItem('companyCode')));
	}

	render() {
		const {
			submitting = false,
			selectTable,
			rciForm,
			refreshList,
			empRciList = [],
			status = 'loaded',
			filter
		} = this.state;

		if (filter) {
			filter.onClickItem = (state) => {
				RepairClockInDataUtils.empRciApplyList({
					page: 1,
					state: state
				});
				if (state != 'edit') {
					dispatch({
						type: 'close-rci-record-selectable'
					});
				}
			};
		}

		if (refreshList) {
			setTimeout(() => {
				location.reload();
			}, 0);
		}
		//console.log(empRciList);
		return (
			<div>
				<Header
					back
					title={getLang('MY_APPLY')}
					dropdown={filter}
				/>
				<PullLoader ref="pullLoader" status={status} onLoad={::this.loadMore}>
					<ul className={'record-list' + (selectTable ? ' record-list-selectable' : '')}>
					{
						empRciList.map((record, index) => {
							return (
								<li>
									<a className='record-item record-item-plus' href={`#/my-rci/record/` + record.app_001_id} onClick={this.checkEdit.bind(this, record)}>
										<span className='record-item-name'> {record.app_001_c001v}</span>
										<span className='record-item-time'>{record.app_001_sdate} - {record.app_001_edate}</span>
										<span className={'record-item-status'}>{record.app_statev}</span>
									</a>
								</li>
							);
						})}
				</ul>
				</PullLoader>
				
			<Button icon='plus' action onClick={::this.openApply} />

				< PageOpener ref= 'apply' >
					<Loader status={status}>
						{/*<div className='login-forgot-page'>
							<FormControl label={'理由'} tips={getLang('REQUIRED')}>
								<TextInput ref='tbReason' id='tbReason' name='tbReason'
									type='text' required />
							</FormControl>
							<FormControl label={'开始时间'} tips={getLang('REQUIRED')}>
								<TextInput ref='tbStartTime' id='tbStartTime' name='tbStartTime'
									type='datetime' required />
							</FormControl>
							<FormControl label={'结束时间'} tips={getLang('REQUIRED')}>
								<TextInput ref='tbEndTime' id='tbEndTime' name='tbEndTime'
									type='datetime' required />
							</FormControl>
						</div>*/}
						<Form className='side-gap pad-b'
							controls={rciForm}
							ref='applyForm' />
						<div className="row">
							<div className="col-1-2">
								<Button type='button'
									disabled={submitting}
									text={getLang('SAVE')} onClick={this.insert.bind(this, false)} />
							</div>
							<div className="col-1-2">
								<Button type='button'
									disabled={submitting}
									text={getLang('SUBMIT')} onClick={this.insert.bind(this, true)} />
							</div>
						</div>
					</Loader>
				</PageOpener >
			</div >
		);
	}

/**
 * 加载更多
 */
loadMore() {
	//alert(1);
	const currentQuery = this.state.empRciListQuery;
	
	RepairClockInDataUtils.empRciApplyList({
		...currentQuery,
		page: currentQuery.page + 1
	});
}

checkEdit(item, e) {
	//什么情况下，才可以编辑0或1
	//目前是先写1
	if (parseInt(item.app_state) === 0) {
		e.preventDefault();

		this._editId = item.app_001_id;
		RepairClockInDataUtils.getRciEditApplyForm(item.app_001_id);
		this.openApply(e, true);
	}
}

/**
 * 通过配置获取并打开表单
 * 
 * @param {any} e 
 * @param {any} editMode 
 * @returns 
 * 
 * @memberof RepairClockInList
 */
openApply(e, editMode) {
	this.refs.apply.open(e);
	this.refs.pullLoader.stopLoading();

	if (editMode === true) {
		this.url = '/ess-edit-repair-timeclock';
		return;
	} else {
		this.url = '/ess-insert-repair-timeclock';
	}

	RepairClockInDataUtils.getRciApplyForm();
}

/**
 * 新增表单
 * - save: { submit: false}
 * - submit: { submit: true }
 * @param submitValue
 */
insert(submitValue, e) {
	const formData = this.collectFormData(submitValue);

	if (!formData) return;

	RepairClockInDataUtils.empRciApplyInsert(formData, this.url);

	e.preventDefault();
}

/**
 * 若表单合法, 返回 formData
 * 若不合法, 返回 false
 * @param {boolean} submitValue
 * @returns {boolean|*}
 */
collectFormData(submitValue) {
	const form = this.refs.applyForm,
		formData = new FormData(React.findDOMNode(form));

	if (!form.isValid() || window.leaveValidation && !window.leaveValidation()) return;

	formData.append('submit', submitValue);

	formData.append('verify', false);

	if (this._editId) {
		formData.append('id', this._editId);
	}

	return formData;
}

	/**
	 * 关闭申请框, 并清除数据
	 */
// 	closeFormAndRefreshList() {
// 		const inputs = React.findDOMNode(this.refs.applyForm).querySelectorAll('input, select, textarea');

// 		for (let i = 0; i < inputs.length; i += 1) {
// 			inputs[i].value = '';
// 		}

// 		this.refs.apply.close();
//     	this.refs.pullLoader.continueLoading();
//    }
}
export default Container.create(RepairClockInList);






// WEBPACK FOOTER //
// ./src/containers/RepairClockIn/RepairClockInEmpListContainer.js